import * as actionType from '../actions/actionTypes'
import updateObject from '../Utility';

const initialState = {
    notificationList: []
}

const fetchNotificationSuccess = (state, action) => {
    return updateObject(state, { notificationList: action.notifications })
}

const addNewNotification = (state, action) => {
    const newNotificationList = [...state.notificationList]
    newNotificationList.push(action.notificationObj)
    newNotificationList.sort((a, b) => a.notificationTime >= b.notificationTime?1:-1)
    return updateObject(state, { notificationList: newNotificationList })
}

const deleteNotification = (state, action) => {
    const newNotificationList = [...state.notificationList]
    const notificationIndex = newNotificationList.findIndex(notification => notification._id === action.notificationId)
    if (notificationIndex > -1) {
        newNotificationList.splice(notificationIndex, 1)
    }
    return updateObject(state, { notificationList: newNotificationList })
}

const updateNotification = (state, action) => {
    const newNotificationList = [...state.notificationList]
    const notificationIndex = newNotificationList.findIndex(notification => notification._id === action.notificationObj._id)
    if (notificationIndex > -1) {
        newNotificationList.splice(notificationIndex, 1, action.notificationObj)
        newNotificationList.sort((a, b) => a.notificationTime >= b.notificationTime?1:-1)
    }

    return updateObject(state, { notificationList: newNotificationList })
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.CLEAR_NOTIFICATIONS_STATE: return initialState
        case actionType.FETCH_NOTIFICATIONS_SUCCESS: return fetchNotificationSuccess(state, action)
        case actionType.ADD_NEW_NOTIFICATIONS: return addNewNotification(state, action)
        case actionType.UPDATE_NOTIFICATION: return updateNotification(state, action)
        case actionType.DELETE_NOTIFICATION: return deleteNotification(state, action)
        default: return state
    }
}

export default reducer